import { immer } from 'zustand/middleware/immer'
import { createWithEqualityFn as create } from 'zustand/traditional'
import { shallow } from 'zustand/vanilla/shallow'

import { createSelectors } from '@/shared/lib/createSelectors.ts'

interface State {
	reasonPopupId: string | null
}

interface Actions {
	setReasonPopupId: (id: string | null) => void
}

/**
 * Store for save reasonPopupId for shared state between hooks
 *
 * @author Ivan Shchedrovskyi
 */
export const useCoreOfferReasonPopupStoreBase = create<State & Actions>()(
	immer(set => ({
		reasonPopupId: null,
		setReasonPopupId: id =>
			set(state => {
				state.reasonPopupId = id
			})
	})),
	shallow
)

export const useCoreOfferReasonPopupStore = createSelectors(
	useCoreOfferReasonPopupStoreBase
)
